<style lang="scss" scoped>
#nova-devolucao-form {
  .container {
    max-width: 850px;
  }
}
</style>
<template>
  <div id="nova-devolucao-form">
    <v-container class="container">
      <v-card>
        <v-toolbar elevation="1" color="primary" dark>
          <v-btn to="/devolucoes" exact icon>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title>
            Nova Devolução
            <v-spacer></v-spacer>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn to="/devolucoes" exact icon>
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-row>
        <v-col>
          <v-card :disabled="loading">
            <v-card-title>
              <v-icon left>mdi-package-variant-closed</v-icon>
              Produtos
            </v-card-title>
            <v-card-text style="overflow-x: auto">
              <v-alert
                text
                transition="slide-y-transition"
                v-model="hasProductErrors"
                type="error"
                dismissible
                border="left"
              >
                {{ producstErrorMessage }}
              </v-alert>
              <SeletorProduto @submit="addProduct" />
              <div
                v-for="(product, index) in products"
                :key="index"
                class="mb-1"
              >
                <v-divider v-if="index > 0"></v-divider>
                <ProductCard
                  :product="product"
                  :index="index"
                  @remove="removeProduct"
                  @edit="editProduct"
                />
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-list-item class="mx-2">
              <v-list-item-content>
                <v-list-item-title>
                  <b>
                    Total
                  </b>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <b>
                  {{ formatMoney(total) }}
                </b>
              </v-list-item-action>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card :disabled="loading">
            <ValidationObserver ref="form" v-slot="{ invalid }">
              <v-form @submit.prevent="handleCreateDevolution()">
                <v-card-title>
                  <v-icon left>mdi-account-details</v-icon>
                  Cliente e Pagamento
                </v-card-title>
                <v-card-text>
                  <SeletorCliente @submit="addCliente($event)" />
                  <v-list-item v-if="client" class="px-0">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ client.nome }}
                        <span v-if="client.deleted_at">
                          (Excluído)
                        </span>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Cód {{ client.id }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <span
                          :class="{
                            'green--text': client.credito_disponivel > 0,
                            'red--text': client.credito_disponivel <= 0
                          }"
                        >
                          {{ formatMoney(client.credito_disponivel) }}
                        </span>
                        disponível
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action v-if="!readonly">
                      <v-btn @click="addCliente(null)" icon>
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <ValidationProvider
                    name="payment_type_id"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <devolution-payment-types-picker
                      v-model="payment_type_id"
                      label="Escolha uma forma de pagamento"
                      name="payment_type_id"
                      :error-messages="errors"
                    />
                  </ValidationProvider>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :loading="loading" type="submit" exact color="primary">
                    <v-icon left>mdi-check</v-icon>
                    Cadastrar
                  </v-btn>
                </v-card-actions>
              </v-form>
            </ValidationObserver>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <ProductSaleForm ref="productForm" @submit="saveProduct" />
  </div>
</template>

<script>
import MoneyMixin from "@/mixins/MoneyMixin";

import DevolutionPaymentTypesPicker from "@/components/DevolutionPaymentTypesPicker";
import ProductCard from "@/components/ProductCard";
import ProductSaleForm from "@/components/ProductSaleForm";
import SeletorProduto from "@/components/produtos/SeletorProduto";
import SeletorCliente from "@/components/clientes/SeletorCliente";

export default {
  components: {
    DevolutionPaymentTypesPicker,
    ProductCard,
    ProductSaleForm,
    SeletorProduto,
    SeletorCliente
  },
  mixins: [MoneyMixin],
  data: function() {
    return {
      products: [],
      readonly: false,
      client_dialog: false,
      client_id: null,
      client: null,
      payment_type_id: null,
      loading: false,
      hasProductErrors: false,
      producstErrorMessage: ""
    };
  },
  methods: {
    addCliente(cliente) {
      if (!cliente) {
        this.client = null;
        this.client_id = null;
        return;
      }

      this.client = cliente;
      this.client_id = cliente.id;
    },
    editProduct(product, index) {
      this.$refs.productForm.init(product, index);
    },
    saveProduct(payload, product_index) {
      this.products = this.products.map((product, index) => {
        if (index === product_index) {
          return { ...payload };
        }

        return product;
      });
      this.dialog = false;
    },
    calcTotalProduct(sale_product) {
      return sale_product.quantidade_produto * sale_product.preco_venda;
    },
    getProductName(product) {
      return `${product.nome} ${product.marca} (${product.unidade_medida})`;
    },
    removeProduct(index) {
      console.log(index);
      this.products.splice(index, 1);
    },
    addProduct(product) {
      const produto_id = product.id;
      this.products.unshift({
        ...product,
        quantidade_produto: 1,
        produto_id
      });
    },
    async isFormValid() {
      const formValidation = await this.$refs.form.validate();

      if (formValidation) {
        // Verifica produtos
        if (this.products.length > 0) {
          return true;
        } else {
          this.producstErrorMessage = "A devolução deve ter produtos";
          this.hasProductErrors = true;
        }
      }

      return false;
    },
    async handleCreateDevolution() {
      const isValid = await this.isFormValid();

      if (isValid) {
        this.loading = true;
        try {
          const response = await this.$http.post("/devolucoes", {
            produtos: this.products,
            devolucao: {
              cliente_id: this.client_id,
              payment_type_id: this.payment_type_id
            }
          });

          this.$router.push(`/devolucoes/${response.data.numero}`);
        } catch (error) {
          if (error.response) {
            switch (error.response.status) {
              case 400:
                this.$store.commit("error", error.response.data.message);
                break;
              case 500:
                this.$store.commit("error", "Falha ao processar");
                break;
            }
          } else {
            this.$store.commit("error", error.message);
          }
        } finally {
          this.loading = false;
        }
      }
    }
  },
  computed: {
    total: function() {
      let total = 0;
      this.products.forEach(product => {
        total += this.calcTotalProduct(product);
      });

      return total;
    }
  }
};
</script>
